import React from "react";
import { useTranslation } from "react-i18next";
import maintenanceImg from "../assets/maintenance.png";

const Maintenance = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center maintenance">
      <div>
        <img src={maintenanceImg} alt="Maintenance" />
      </div>
      <h2>{t("currentlyUnavailable")}</h2>
    </div>
  );
};

export default Maintenance;
